export default __webpack_public_path__ + "static/media/Ilustrace 1.ef103231.png";